import { AxiosRequest } from 'src/lib/axios/Axios';

export type ChangePublicationConfigValuesPayload = {
  publicationId: string | number;
  configValues: Record<string, unknown>;
};

export const changePublicationConfigValues = async ({
  publicationId,
  configValues,
}: ChangePublicationConfigValuesPayload): Promise<void> => {
  await AxiosRequest.put(`/publications/${publicationId}/config-values`, {
    config_values: configValues,
  });
};
